/**
 * useProviderExport Hook
 * Custom hook for exporting providers to Excel
 */

import { useState, useCallback } from 'react';
import { providerService, ProviderFilters } from '../services/providerService';
import { useSnackbar } from 'notistack';

interface UseProviderExportResult {
  exporting: boolean;
  exportProviders: (filters?: Partial<ProviderFilters>, filename?: string) => Promise<void>;
}

export const useProviderExport = (): UseProviderExportResult => {
  const { enqueueSnackbar } = useSnackbar();

  const [exporting, setExporting] = useState<boolean>(false);

  const exportProviders = useCallback(async (
    filters?: Partial<ProviderFilters>,
    filename = 'prestadores.xlsx'
  ): Promise<void> => {
    try {
      setExporting(true);

      const blob = await providerService.exportProviders(filters);

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      enqueueSnackbar('Prestadores exportados com sucesso', { variant: 'success' });
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Erro ao exportar prestadores';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      setExporting(false);
    }
  }, [enqueueSnackbar]);

  return {
    exporting,
    exportProviders
  };
};
